import { render } from "./ZNWBadd.vue?vue&type=template&id=87dfb670&scoped=true"
import script from "./ZNWBadd.vue?vue&type=script&lang=js"
export * from "./ZNWBadd.vue?vue&type=script&lang=js"

import "./ZNWBadd.vue?vue&type=style&index=0&id=87dfb670&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87dfb670"]])

export default __exports__